export const SET_TRX_GOLD_LIST = 'SET_TRX_GOLD_LIST';
export const UPDATE_GOLD_STATUS = 'UPDATE_GOLD_STATUS';
export const PROCESSING = 'PROCESSING';

export const SET_ACCOUNT_DETAIL = 'SET_ACCOUNT_DETAIL';
export const GET_ACCOUNT_TRANSACTION = 'GET_ACCOUNT_TRANSACTION';
export const SET_ACCOUNT_TRANSACTION = 'SET_ACCOUNT_TRANSACTION';
